export default __webpack_public_path__ + "static/boat-3e1637d5fb5e631a2e8a76e05d39132c.jpg";